import { FilterField } from './FilterField';

export interface SearchFilterProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /** When set, renders a label above the input (e.g. "Search"). */
  label?: string;
  className?: string;
  id?: string;
  disabled?: boolean;
}

const inputBaseClassName =
  'w-full bg-background border border-border rounded-md text-foreground text-sm py-2 transition-colors focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/20';

export function SearchFilter({
  value,
  onChange,
  placeholder = 'Search...',
  label: labelProp,
  className = '',
  id,
  disabled = false,
}: Readonly<SearchFilterProps>) {
  const showClear = Boolean(value) && !disabled;

  const control = (
    <div className="relative">
      <input
        id={id}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={e => onChange(e.target.value)}
        className={`${inputBaseClassName} ${showClear ? 'pl-3 pr-9' : 'px-3'}`}
        disabled={disabled}
      />
      {showClear && (
        <button
          type="button"
          onClick={() => onChange('')}
          onMouseDown={e => e.preventDefault()}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded text-muted-foreground hover:text-foreground hover:bg-muted/50"
          aria-label="Clear search"
        >
          <svg
            className="h-4 w-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  );

  const wrapperClass =
    'flex-1 min-w-[200px] max-w-full min-w-0'; /* dynamic fit: grows in row */
  return (
    <div className={[wrapperClass, className].filter(Boolean).join(' ')}>
      <FilterField label={labelProp} id={id}>
        {control}
      </FilterField>
    </div>
  );
}
